import { getTextElementNumberOfLines } from '@utils/browser-utils';
import Rating from '@utils/rating';

import jQuery from 'jquery';

const getCardsPerRow = () => {
  return Math.floor(
    (jQuery('.grid-rec-objects-container').width() + 20) / (jQuery('.grid-rec-object-container').width() + 20)
  );
};

const isSingleLineNameOnly = (recObject, configStore, groupStore) => {
  // Check if name fits on a single line. If it's not rendered yet (element not found), fall back to logic
  // of 28 characters or less.
  const numberOfLinesInName = getTextElementNumberOfLines(`[data-rec-object-id='${recObject.id}'] .rec-object-name1`);

  const nameOnSingleLine =
    numberOfLinesInName === undefined
      ? recObject.display_name && recObject.display_name.length <= 28
      : numberOfLinesInName === 1;

  let showRatings = false;
  const rating = recObject.rec_ratings[0];
  const ratingsShownForGroup = groupStore.show_review_sites;
  if (rating && ratingsShownForGroup) {
    const ratingConfig = Rating.configDataForRating(rating, configStore);
    showRatings = Rating.shouldShowRating(recObject, rating, ratingConfig, false);
  }

  const noCategories = !recObject.categories.length;
  const noName2 = !(recObject.name2 && recObject.name2.length);

  return nameOnSingleLine && !showRatings && noCategories && noName2;
};

export const getRecObjectIdsForSection = (sectionEl) => {
  var ids = [];

  if (sectionEl) {
    jQuery(sectionEl)
      .find('[data-rec-object-id]')
      .each(function () {
        ids.push(jQuery(this).data('rec-object-id'));
      });
  }

  return ids;
};

export const isWholeRowSingleLineOnly = (recObject, recObjectsStore, sortedRecObjectIds, configStore, groupStore) => {
  const cardsPerRow = getCardsPerRow();
  const currentRecObjectIndex = sortedRecObjectIds.findIndex((id) => id === recObject.id);
  const positionInRow = currentRecObjectIndex % cardsPerRow;

  const startOfRow = currentRecObjectIndex - positionInRow;
  const endOfRow = Math.min(startOfRow + cardsPerRow, sortedRecObjectIds.length);

  let allObjectsWithSinglePhoto = true;

  for (let i = startOfRow; i < endOfRow; i++) {
    let recObj = recObjectsStore.find(sortedRecObjectIds[i]);

    if (recObj && recObj.rec_object_photos && recObj.rec_object_photos.length > 1) {
      allObjectsWithSinglePhoto = false;
    }

    if (!recObj || isSingleLineNameOnly(recObj, configStore, groupStore) === false) {
      return false;
    }
  }

  return allObjectsWithSinglePhoto;
};
